import React, { createContext, useContext, useState, useMemo } from 'react';
import {
  INITIAL_FILTER_UI_STATE,
  INITIAL_FILTER_COMPONENT_STATE,
} from './initialState';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [filterUIState, setFilterUIState] = useState(INITIAL_FILTER_UI_STATE);
  const [filterComponentState, setFilterComponentState] = useState(INITIAL_FILTER_COMPONENT_STATE);

  const [priceFilter, setPriceFilter] = useState({ minPrice: null, maxPrice: null });
  const [householdFilter, setHouseholdFilter] = useState({ minHousehold: null, maxHousehold: null });
  const [areaFilter, setAreaFilter] = useState({ minArea: null, maxArea: null });
  const [gapFilter, setGapFilter] = useState({ minGap: null, maxGap: null });
  const [moveInDateFilter, setMoveInDateFilter] = useState({ minYears: null, maxYears: null });
  const [subdistrictFilter, setSubdistrictFilter] = useState([]);
  const [subwayFilter, setSubwayFilter] = useState(null);
  const [gangnamTimeFilter, setGangnamTimeFilter] = useState({ maxTime: null });
  const [schoolFilter, setSchoolFilter] = useState(null);

  const resetFilterState = () => {
    setFilterUIState(INITIAL_FILTER_UI_STATE);
    setFilterComponentState(INITIAL_FILTER_COMPONENT_STATE);
    setPriceFilter({ minPrice: null, maxPrice: null });
    setHouseholdFilter({ minHousehold: null, maxHousehold: null });
    setAreaFilter({ minArea: null, maxArea: null });
    setGapFilter({ minGap: null, maxGap: null });
    setMoveInDateFilter({ minYears: null, maxYears: null });
    setSubdistrictFilter([]);
    setSubwayFilter(null);
    setGangnamTimeFilter({ maxTime: null });
    setSchoolFilter(null);
  };

  return (
    <FilterContext.Provider
      value={useMemo(() => ({
        filterUIState, setFilterUIState,
        filterComponentState, setFilterComponentState,
        priceFilter, setPriceFilter,
        householdFilter, setHouseholdFilter,
        areaFilter, setAreaFilter,
        gapFilter, setGapFilter,
        moveInDateFilter, setMoveInDateFilter,
        subdistrictFilter, setSubdistrictFilter,
        subwayFilter, setSubwayFilter,
        gangnamTimeFilter, setGangnamTimeFilter,
        schoolFilter, setSchoolFilter,
        resetFilterState,
      }), [filterUIState, filterComponentState, priceFilter, householdFilter, areaFilter, gapFilter, moveInDateFilter, subdistrictFilter, subwayFilter, gangnamTimeFilter, schoolFilter])}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => useContext(FilterContext);
